import React from 'react'
import { components } from 'react-select'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

import SelectDropdown, { themeSelectDropdownWhite } from 'components/SelectDropdown'

import { usePopulationSetting } from 'flow/settings/population'

const Grade = styled.div(({ theme }) => css`
  padding-left: 20px;
  color: ${theme.blueElectricLight};
  font-weight: 400;
`)

const OptionWith2Cols = props => {
  const { data: { grade, tooltip } } = props
  return (
    <div title={tooltip}>
      <components.Option {...props}>
        {props.children}
        {grade && <Grade>{grade}</Grade>}
      </components.Option>
    </div>
  )
}

const SelectPopulation = (props) => {
  const [selectedPopulation, population, setPopulation] = usePopulationSetting()

  const groupedOptions = [{
    label: 'Population',
    options: population
  }]

  return (
    <SelectDropdown
      options={groupedOptions}
      selected={selectedPopulation}
      onChange={setPopulation}
      customOption={OptionWith2Cols}
      customTheme={themeSelectDropdownWhite}
    />

  )
}

export default SelectPopulation
